export const AUTH_START = 'm_AUTH_START'
export const AUTH_SUCCESS = 'm_AUTH_SUCCESS'
export const AUTH_CLEAR = 'm_AUTH_CLEAR'
export const AUTH_ERROR = 'm_AUTH_ERROR'
export const AUTH_SET_REF_PARISH = 'm_AUTH_SET_REF_PARISH'

export default {
  [AUTH_START] (state) {
    state.status = 'loading'
  },
  [AUTH_SUCCESS] (state, token) {
    state.token = token
    state.status = 'success'
  },
  [AUTH_CLEAR] (state, status) {
    localStorage.removeItem('auth-token')
    state.token = null
    state.status = status || 'clear'
  },
  [AUTH_ERROR] (state) {
    state.status = 'error'
  },
  [AUTH_SET_REF_PARISH] (state, parish) {
    state.parish = parish
  }
}
